import club from "@store/club";
import auth from "@store/auth";
import session from "@store/session";
const modules = {
  club,
  auth,
  session,
};
export default modules;
